"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _index = _interopRequireDefault(require("./index.vue"));

var _componentRender = _interopRequireDefault(require("../_utils/component-render"));

var userPreference = (0, _componentRender.default)(_index.default);

_index.default.open = function (data) {
  if (data === void 0) {
    data = {};
  }

  return userPreference(data).run();
};

var _default = _index.default;
exports.default = _default;